import { FormBuilder, Validators, FormGroup } from '@angular/forms';

export class PaymentLineFactory {
	static createCashLine(fb: FormBuilder, data?: any): FormGroup {
		let initialDate = data?.date ? new Date(data.date) : new Date();
		initialDate.setHours(0, 0, 0, 0);
		return fb.group({
			id: [data?.id || data?.receipt_detail_id || null],
			date: [initialDate, Validators.required],
			amount: [data?.amount || 0, [Validators.required, Validators.min(0.01)]],
			payment_type: [1]
		});
	}

	static createCheckLine(fb: FormBuilder, data?: any): FormGroup {
		let initialDate = data?.date ? new Date(data.date) : new Date();
		initialDate.setHours(0, 0, 0, 0);
		return fb.group({
			id: [data?.id || data?.receipt_detail_id || null],
			date: [initialDate, Validators.required],
			bank: [data?.bank || ''],
			branch: [data?.branch || ''],
			account: [data?.account || ''],
			check: [data?.check || data?.reference || ''],
			amount: [data?.amount || 0, [Validators.required, Validators.min(0.01)]],
			payment_type: [2]
		});
	}

	static createBankPaymentLine(fb: FormBuilder, data?: any): FormGroup {
		let initialDate = data?.date ? new Date(data.date) : new Date();
		initialDate.setHours(0, 0, 0, 0);
		return fb.group({
			id: [data?.id || data?.receipt_detail_id || null],
			date: [initialDate, Validators.required],
			amount: [data?.amount || 0, [Validators.required, Validators.min(0.01)]],
			account: [data?.account || data?.account || ''],
			bank: [data?.bank || ''],
			payment_type: [4]
		});
	}

	static createCreditLine(fb: FormBuilder, data?: any): FormGroup {
		let initialDate = data?.date ? new Date(data.date) : new Date();
		initialDate.setHours(0, 0, 0, 0);
		return fb.group({
			id: [data?.id || data?.receipt_detail_id || null],
			date: [initialDate, Validators.required],
			amount: [data?.amount || 0, [Validators.required, Validators.min(0.01)]],
			credit_card_code: [data?.credit_card_code || ''],
			credit_card_name: [data?.credit_card_name || ''],
			credit_type: [data?.credit_type || ''],
			account: [data?.account || data?.account || ''],
			payment_type: [3]
		});
	}
}
